var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v("Firerbaseユーザー検索")]),_c('v-text-field',{attrs:{"label":"Firebase uid","outlined":""},model:{value:(_vm.uid),callback:function ($$v) {_vm.uid=$$v},expression:"uid"}}),_c('v-btn',{attrs:{"loading":_vm.isLoading},on:{"click":_vm.search}},[_vm._v("検索")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }